import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import Connect from '../views/Connect.vue'
import Service from '../views/Service.vue'
import Product from '../views/Product.vue'
import About from '../views/About_bak.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
  path: '/',
  component: Home,
  children: [{
    path: '/',
    component: Main
  }, {
    path: 'service',
    component: Service
  }, {
    path: 'product',
    component: Product
  }, {
    path: 'about',
    component: About,
    children: [{
      path: '/',
      component: Main
    }]
  }, {
    path: 'connect',
    component: Connect
  }]
}]

const router = new VueRouter({
  mode:'history',
  base:'/',
  routes
})

router.beforeEach((to, from, next) => {

  document.title = "中讯亚太官网";
  next()
})
export default router